"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyNotice = void 0;
class StudyNotice {
}
exports.StudyNotice = StudyNotice;
//# sourceMappingURL=studyNotice.js.map